export class NatureOfBusiness {
    natureName: string;
    businessList: string[];

    constructor(natureName: string, businessList: string[]) {
        this.natureName = natureName;
        this.businessList = businessList;
    }
}
